export enum Plataforma {
    "ERP" = "ERP"
}